/**
 * FeedbackFab — Floating action button that opens the FeedbackSheet.
 * Renders only for authenticated users.
 */

import { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { ds } from '../../../design-system/tokens';
import { FeedbackSheet } from '../../../design-system/patterns';
import { Tooltip } from './Tooltip';
import { useProfile } from '../../contexts/ProfileContext';

export function FeedbackFab() {
  const { pilotInfo } = useProfile();
  const [isOpen, setIsOpen] = useState(false);

  if (!pilotInfo) return null;

  return (
    <>
      {!isOpen && (
        <div className="fixed bottom-6 right-6 z-[10100]">
          <Tooltip text="Feedback" position="left">
            <button
              onClick={() => setIsOpen(true)}
              className="w-12 h-12 rounded-full text-white shadow-lg flex items-center justify-center"
              aria-label="Send feedback"
              style={{
                backgroundColor: ds.color.button.primary.bg,
                transition: 'background-color 120ms ease-in-out, transform 120ms ease-in-out',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = ds.color.button.primary.hover;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = ds.color.button.primary.bg;
                e.currentTarget.style.transform = 'scale(1)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = ds.color.button.primary.press;
                e.currentTarget.style.transform = 'scale(0.97)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.backgroundColor = ds.color.button.primary.hover;
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <MessageSquare className="w-5 h-5" />
            </button>
          </Tooltip>
        </div>
      )}

      <FeedbackSheet isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
